var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.item.is_loading, rounded: "sm" } },
    [
      _c(
        "a",
        {
          staticClass: "waves-effect waves-themed pl-1 pr-1",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("edit", _vm.item)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "loc_click p-2",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.$emit("toggle", _vm.item)
                },
              },
            },
            [
              _c("b-form-checkbox", {
                attrs: { name: "loc_" + _vm.item.id, id: "loc_" + _vm.item.id },
                model: {
                  value: _vm.item.is_checked,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "is_checked", $$v)
                  },
                  expression: "item.is_checked",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-link-text color-black d-block" },
            [
              _c("div", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.item.title) +
                    "\n                "
                ),
                _c("sup", [
                  _c("span", { staticClass: "badge badge-warning ml-2" }, [
                    _vm._v(
                      "\n                      " +
                        _vm._s(_vm.item.uniq_id) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.hasDelivery
                  ? _c("sup", [
                      _c("span", { staticClass: "badge badge-info ml-2" }, [
                        _vm._v(
                          "\n                      " +
                            _vm._s(_vm.__t("AUTO_DELIVERY")) +
                            "\n                    "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.item.linked_restaurant
                ? _c("div", { staticClass: "small" }, [
                    _vm._v(
                      "\n                LINK_REST: " +
                        _vm._s(_vm.item.linked_restaurant.address) +
                        " |\n                " +
                        _vm._s(_vm.item.linked_restaurant.title) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("base_location_status", { attrs: { cur_location: _vm.item } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-icon btn-sm btn-danger rounded-circle waves-effect waves-themed ml-2 mr-2",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.$emit("remove", _vm.item)
                  },
                },
              },
              [_c("i", { staticClass: "fal fa-trash" })]
            ),
            _vm._v(" "),
            _vm.hasBusyMode
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-icon btn-sm btn-success waves-effect waves-themed ml-2 mr-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("busy-on", _vm.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-business-time" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasOnline
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-icon btn-sm btn-success waves-effect waves-themed ml-2 mr-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("online", _vm.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-play" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasOffline
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-icon btn-sm btn-info waves-effect waves-themed ml-2 mr-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("offline", _vm.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-stopwatch" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasJson
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-icon btn-sm btn-warning rounded-circle waves-effect waves-themed ml-2 mr-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("json", _vm.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-building" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasPreview
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-icon btn-sm btn-warning rounded-circle waves-effect waves-themed ml-2 mr-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("preview", _vm.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-eye" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSync
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-icon btn-sm btn-success rounded-circle waves-effect waves-themed ml-2 mr-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("sync", _vm.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-sync" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSyncUpdate
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-icon btn-sm btn-warning rounded-circle waves-effect waves-themed ml-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$emit("sync-update", _vm.item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fal fa-sync" })]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }